import React from "react";

const SvgHome = (props) => (
  <svg width="18" viewBox="0 0 18 18" {...props}>
    <path
      d="M16.21 7.2L9 0-.01 8.992l1.27 1.272.53-.534v8.267H8.1v-3.6h1.8v3.6h6.31v-8.25l.52.525L18.01 9zm-1.81 9h-2.7v-3.6H6.3v3.6H3.59V7.933l5.4-5.39 5.41 5.408V16.2z"
      fill={props.color || "currentColor"}
      fillRule="evenodd"
    />
  </svg>
);

export default SvgHome;
